export default "__VITE_ASSET__CJdC8jnY__"